import React from 'react';
import _ from 'lodash';
import IconButton from 'material-ui/IconButton';
import AddCircle from 'material-ui/svg-icons/content/add-circle';
import FontIcon from 'material-ui/FontIcon';

const style = {
    videoIcon: {
        fontSize: '5em',
        position: 'absolute',
        top: '50%',
        left: '50%',
        color: '#00A7F7',
        transform: 'translate(-50%,-50%)'
    },
    deleteIcon: {
        color: '#00A7F7',
        fontSize: 27
    },
    iconButton: {
        color: '#00A7F7',
        position: 'absolute',
        padding: 0,
        top: -5,
        left: -7,
        cursor: 'pointer',
        transform: 'rotate(45deg)'
    }
};

const videoIcon = <FontIcon style={style.videoIcon} className="material-icons">play_arrow</FontIcon>;

// Using "Stateless Functional Components"
export default function(props) {
    let className = 'wt-asset';

    let asset;
    if (props.isVideo) {
        let thumbnail = props.poster || props.thumbnail;
        if (_.isEmpty(thumbnail)) {
            //url = url.startsWith('blob:') ? url : '//' + url;
            asset = videoIcon;
        } else {
            thumbnail = /^(blob|data):/.test(thumbnail) ? thumbnail : '//' + thumbnail;
            asset = <img role="presentation" src={thumbnail} onError={props.onError}/>;
        }
    } else {
        if (_.isEmpty(props.thumbnail)) {
            asset = <h3>Image Error</h3>
        } else {
            const thumbnail = /^(blob|data):/.test(props.thumbnail) ? props.thumbnail : '//' + props.thumbnail;
            asset = <img role="presentation" src={thumbnail} onError={props.onError}/>;
        }
    }

    return <div className={className}>
            <IconButton onTouchTap={props.deleteUpload} className="fill-with-white" style={style.iconButton} iconStyle={style.deleteIcon} >
                <AddCircle/>
            </IconButton>
        {asset}
    </div>;
}
